module.exports = __webpack_public_path__ + "img/1.0af403e4.jpg";